import { render, staticRenderFns } from "./Relatorios.vue?vue&type=template&id=167a2a05&scoped=true"
import script from "./Relatorios.vue?vue&type=script&lang=js"
export * from "./Relatorios.vue?vue&type=script&lang=js"
import style0 from "./Relatorios.vue?vue&type=style&index=0&id=167a2a05&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "167a2a05",
  null
  
)

export default component.exports